import { datadogRum } from '@datadog/browser-rum';

const DATADOG_APPLICATION_ID = '4d63f83c-244b-42bb-ac09-a6ad96346526';
const DATADOG_CLIENT_TOKEN = 'pub9a5660ffbee2be65ac563d787d32f553';

const getReleaseStage = (): string => {
  if (typeof window === 'undefined') {
    return 'production';
  }

  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  }
  if (hostname.includes('-test') || hostname.includes('staging')) {
    return 'staging';
  }
  return 'production';
};

export const isDatadogEnabled = (): boolean =>
  Boolean(DATADOG_APPLICATION_ID) && Boolean(DATADOG_CLIENT_TOKEN);

export const initDatadog = (): void => {
  if (typeof window === 'undefined' || !isDatadogEnabled()) {
    return;
  }

  datadogRum.init({
    applicationId: DATADOG_APPLICATION_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'le-website',
    env: getReleaseStage(),
    version: process.env.NEXT_BUILD_ID ?? 'development',
    sessionSampleRate: 50,
    sessionReplaySampleRate: 10,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
};

export type DatadogUser = {
  id: string;
  name?: string;
  email?: string;
};

export const setDatadogUser = (user: DatadogUser): void => {
  if (!isDatadogEnabled()) {
    return;
  }

  datadogRum.setUser({
    id: user.id,
    name: user.name,
    email: user.email,
  });
};

type RumAttributes = Record<string, string | number | boolean | null>;

export const trackCustomAction = (
  name: string,
  attributes?: RumAttributes
): void => {
  if (!isDatadogEnabled()) {
    return;
  }

  datadogRum.addAction(name, attributes ?? {});
};
